// Filter Actions
export const filterClick = option => ({
  type: 'SELECT_FILTER',
  option,
});

export const clearFilters = () => ({
  type: 'CLEAR_FILTERS',
});
